import styled from "styled-components";

export const ChildListContainer = styled.div`
    padding: 5%;
    display: flex;
    flex-flow: row wrap;
    justify-content:center;
    max-height:60%;
    overflow-y:auto;
    @media screen and (min-width: 1024px) and (max-width: 1600px){
        height:49vh;
    }
    @media screen and (min-width: 600px) and (max-width: 1367px){
        max-height:250px;
    }
    @media only screen and (min-device-width : 750px) and (max-device-width : 1199px) and (orientation : portrait) { 
        justify-content:space-around;
        margin-bottom:4%;
    }
    @media only screen and (min-device-width : 750px) and (max-device-width : 1199px) and (orientation : landscape) { 
        justify-content:space-around;
        margin-bottom:4%;
    }
    @media screen and (min-width: 1600px) and (max-width:1920px) {
            height: 85vh;
    } 
`;
export const ChildList = styled.div`
   position: relative;
   margin: 20px 3%;
   width:25%;

   @media screen and (max-width: 1367px){
    margin: 20px 5%;
   }
   @media screen and (max-width: 600px){
    width:80%;
   }
`;
export const ChildSearchCloseIcon = styled.div`
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    cursor: pointer;
    margin-top: 5px;
    margin-right: 15px;
`
export const RegionName = styled.span`
font-size: 24px;
margin-left: 2vw;
`